import PropTypes from "prop-types";

import { t } from "../../services";
import { Modal, Paragraph2, WrapperContainer } from "../../components";
import { ParagraphWrapper } from "./styled";

const TutorialModalTemplate = ({ id, active, setActive, title, steps }) => {
  return (
    <Modal id={id} active={active} setActive={setActive} title={title} closable>
      {steps.map((step, index) => {
        return (
          <WrapperContainer key={index}>
            {index === 0 ? (
              <WrapperContainer mb={16}>
                <Paragraph2>{t(step.title)}</Paragraph2>
              </WrapperContainer>
            ) : (
              <ParagraphWrapper mt={32} mb={16}>
                <Paragraph2>{t(step.title)}</Paragraph2>
              </ParagraphWrapper>
            )}

            {step.component && step.component}
          </WrapperContainer>
        );
      })}
    </Modal>
  );
};

TutorialModalTemplate.propTypes = {
  id: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      component: PropTypes.node
    })
  ).isRequired
};

export default TutorialModalTemplate;
